export default "__VITE_ASSET__xEuhG_$F__"